import React, { Component, Fragment } from 'react';
import { Button, Icon, Result } from 'antd';
import * as Func from '../../../../helpers/functions';
import DEFINE from '../../../../constants/Define';

export default class ProductReindex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: {},
    };
  }

  componentDidMount() {
    this.setState({ permissions: Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.EXPERIENCE) })
  }

  render() {
    const { t, groupState } = this.props;
    const { isFetching } = groupState;
    const { permissions } = this.state;
    return (
      <Fragment>
        {permissions && permissions.allowReindex ? (
          <Result
            icon={<Icon type="sync" spin={isFetching} />}
            title={t('action.update') + ' ' + t('item.experience.indexSKUs').toLowerCase()}
            extra={<Button type="primary" onClick={this.onReindexProduct} disabled={isFetching}>{t('action.reindex')}</Button>}
          />
        ) : (
            <Result
              status="403"
              title="403"
              subTitle={t('item.experience.unauthorized')}
            />
          )}

      </Fragment>
    );
  }

  onReindexProduct = () => {
    this.props.reindexProduct();
  };

}
